import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function BrandLogo({ tone = 'dark', size = 28, showTag = true }) {
    const isDark = tone === 'dark';

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
            <Box
                component="img"
                src={`${process.env.PUBLIC_URL}/logo192.png`}
                alt=""
                sx={{ width: size, height: size, display: 'block' }}
            />
            <Typography
                component="span"
                sx={{
                    fontWeight: 700,
                    fontSize: size * 0.62,
                    letterSpacing: '-0.02em',
                    color: isDark ? '#FFFFFF' : 'text.primary',
                    lineHeight: 1,
                }}
            >
                contblack
            </Typography>
            {showTag && (
                <Box
                    component="span"
                    sx={{
                        fontSize: 10,
                        fontWeight: 600,
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase',
                        px: 0.75,
                        py: 0.25,
                        borderRadius: 1,
                        color: isDark ? 'rgba(255,255,255,0.72)' : 'text.secondary',
                        border: '1px solid',
                        borderColor: isDark ? 'rgba(255,255,255,0.16)' : 'divider',
                    }}
                >
                    Admin
                </Box>
            )}
        </Box>
    );
}
